import { Lang, Filter } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Question browser',
    fields: {
      filter: {
        label: 'Status',
        options: {
          [Filter.Created]: 'Created',
          [Filter.Answered]: 'Answered',
          [Filter.Followed]: 'Followed',
        },
      },
      category: {
        label: 'Category',
        placeholder: 'select ...',
      },
      search: {
        label: 'Text',
        placeholder: 'word_a word_b   or   "exact phrase"',
      },
    },
    nav: {
      page: 'Page',
    },
    list: {
      pageNo: 'Page #{{ pageNo }}',
      total: 'Page #{{ pageNo }} ({{ first }} - {{ last }}, {{ total }} in total)',
      totalOnePage: 'Page #{{ pageNo }} ({{ total }} in total)',
    },
    buttons: {
      createdBy: 'Created by {{ username }}',
    },
  },
}
